import { BULK_API_URL, API_URL } from '../config/connect';

const getToken = () => localStorage.getItem('access_token');

const authHeaders = () => ({
    Authorization: `Bearer ${getToken()}`,
});

export const downloadBulkTemplate = () => {
    window.open(`${BULK_API_URL}/api/v1/announcements/bulk-upload/template`, '_blank');
};

export const bulkUploadAnnouncements = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await fetch(`${BULK_API_URL}/api/v1/announcements/bulk-upload`, {
        method: 'POST',
        headers: authHeaders(),
        body: formData,
    });
    if (!res.ok) {
        const text = await res.text();
        let msg = text;
        try { msg = JSON.parse(text).detail || JSON.parse(text).message || text; } catch (_) {}
        throw new Error(msg || `Error ${res.status}`);
    }
    return res.json();
};

export const exportMyAnnouncements = async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v) params.append(k, v); });
    const res = await fetch(`${BULK_API_URL}/api/v1/bulk/my-announcements/export?${params}`, {
        headers: authHeaders(),
    });
    if (!res.ok) throw new Error(`Export failed: ${res.status}`);
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'my_announcements.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
};

export const patchAnnouncement = async (announcementId, updateData) => {
    const accessToken = localStorage.getItem('access_token');
    const res = await fetch(`${API_URL}/api/v1/announcement/${announcementId}`, {
        method: 'PATCH',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
    });
    if (!res.ok) {
        const text = await res.text();
        let msg = text;
        try { msg = JSON.parse(text).detail || JSON.parse(text).message || text; } catch (_) {}
        throw new Error(msg || `Error ${res.status}`);
    }
    return res.json();
};

export const bulkPatchAnnouncements = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await fetch(`${BULK_API_URL}/api/v1/bulk/patch-batch`, {
        method: 'POST',
        headers: authHeaders(),
        body: formData,
    });
    if (!res.ok) {
        const text = await res.text();
        let msg = text;
        try { msg = JSON.parse(text).detail || JSON.parse(text).message || text; } catch (_) {}
        throw new Error(msg || `Error ${res.status}`);
    }
    return res.json();
};
